import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const InsertQuoteIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "InsertQuote",
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.7 13.21H6.91c-.25 0-.5.03-.73.08h.03V8.31c0-.39.31-.7.7-.7H9.7a2.1 2.1 0 1 0 0-4.2H6.91c-2.71 0-4.9 2.2-4.9 4.9v8.4q0 .3.09.57c-.05.24-.08.53-.08.82v5.6c0 2.71 2.2 4.9 4.9 4.9h2.79c2.71 0 4.9-2.2 4.9-4.9v-5.6c0-2.7-2.2-4.89-4.9-4.89Zm15.39 0H22.3c-.25 0-.5.03-.73.08h.03V8.31c0-.39.31-.7.7-.7h2.8a2.1 2.1 0 1 0 0-4.2h-2.8c-2.71 0-4.9 2.2-4.9 4.9v8.4q0 .3.09.57c-.05.24-.08.53-.08.82v5.6c0 2.71 2.2 4.9 4.9 4.9h2.8c2.71 0 4.9-2.2 4.9-4.9v-5.6c0-2.7-2.2-4.89-4.9-4.89h-.01Z"
    })
  }));
};